export default {options:{},children:[{options:{key:'fallback',type:'value'}},{options:{key:'product',type:'value'}},{options:{key:'ticketType',type:'value'}}]}